import React from 'react';

import { Avatar, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from './style';

type Props = {
  name: string;
  avatar: string;
  email: string;
};

const ClientInformation = ({ avatar, email, name }: Props) => {
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        strong
        fontColor="secondary"
        className="section-title"
      >
        CLIENT INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Client Name :</Typography>
          <div className="value">
            <Avatar src={avatar} size={'xsm'} />
            <Typography>{name}</Typography>
          </div>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Email Address :</Typography>
          <Typography className="value">{email}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default ClientInformation;
